import { Component, Inject } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';

@Component({
    selector: 'app-text-dialog',
    imports: [
        MatDialogModule,
        MatFormFieldModule,
        MatInputModule,
        MatButtonModule,
        ReactiveFormsModule
    ],
    templateUrl: './text-item-dialog.component.html',
    styleUrl: './text-item-dialog.component.scss'
})
export class TextItemDialogComponent {
  textForm: FormGroup;

  constructor(
    private dialogRef: MatDialogRef<TextItemDialogComponent>,
    private fb: FormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: { title: string; content: string }
  ) {
    this.textForm = this.fb.group({
      title: [data?.title || ''],
      content: [data?.content || '', Validators.required]
    });
  }


  onSubmit() {
    if (this.textForm.valid) {
      this.dialogRef.close(this.textForm.value);
    }
  }

  closeDialog() {
    this.textForm.reset();
    this.dialogRef.close();
  }
}